import { CuriosityTranslation } from '@procureai/curiosity-ui-mui';
import { HTMLAttributes } from 'react';

export interface SupplierContactEntity {
  sourceReference?: string;
  firstName: string;
  lastName: string;
  preferredLanguage: string;
  email: string;
  roles: string[];
  isEditable?: boolean;
}
export interface SupplierLocationEntity {
  sourceReference?: string;
  address: string;
  city: string;
  postalCode: string;
  countryCode: string;
}

export enum SupplierContactHitId {
  NEW = 'NEW',
}

export type SupplierContactAutocompleteHit = CuriosityTranslation<SupplierContactEntity>;
export type SupplierLocationAutocompleteHit = CuriosityTranslation<SupplierLocationEntity>;

export interface SupplierOptionProps extends HTMLAttributes<HTMLLIElement> {
  data: SupplierContactAutocompleteHit;
  onSecondaryActionClick: () => void;
}
